import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedPlatforms from './components/FeaturedPlatforms';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '亚洲无码正版内容平台推荐指南',
    description: '正版授权内容平台推荐、观看指南及版权合规说明，帮助用户安全合法获取亚洲无码影音资源。',
    url: 'https://shakea1.cn',
    isPartOf: {
      '@type': 'WebSite',
      name: '亚洲无码正版内容平台推荐指南',
      url: 'https://shakea1.cn',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedPlatforms />
        <CategoryGrid />
        <LatestArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}